import React, { useState } from "react";
import { Button, Dropdown, Table, Modal, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/FBSales.css"
import { toast } from "react-toastify";
import ResultsPagination from "../components/ResultsPagination";
import { useEffect } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
function FeedBackSales() {
  const [activeTimeRange, setActiveTimeRange] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("All");
  const [page, setPage] = useState(1);
  const [customers, setCustomers] = useState([]);
  const [total, setTotal] = useState(0);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editFormData, setEditFormData] = useState({
    _id: "",
    customer: "",
    company: "",
    email: "",
    rating: "",
    support_response: "",
    message: ""
  });

  const handleEdit = (item) => {
    setEditFormData({
      _id: item._id,
      customer: item.customer || "",
      company: item.company || "",
      email: item.email || "",
      rating: item.rating || "",
      support_response: item.support_response || "",
      message: item.message || ""
    });
    setShowEditModal(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: value }));
  };

  const saveEdit = async () => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_BASE_API_URL}/api/feedbacks/${editFormData._id}`, editFormData);
      if (res.data.success) {
        setFeedbacks(prev => prev.map(f => f._id === editFormData._id ? { ...f, ...editFormData } : f));
        setShowEditModal(false);
        toast.success("Feedback updated successfully!", {
          style: {
            borderRadius: '10px',
            background: '#333',
            color: '#fff',
          },
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to update feedback");
    }
  };

  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    try {
      const res = await axios.delete(`${process.env.REACT_APP_BASE_API_URL}/api/feedbacks/${itemToDelete._id}`);
      if (res.data.success) {
        setFeedbacks(prev => prev.filter(f => f._id !== itemToDelete._id));
        setShowDeleteModal(false);
        toast.success("Deletion done!", {
          style: {
            borderRadius: '10px',
            background: '#333',
            color: '#fff',
          },
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete feedback");
    }
  };

  const [selectedCustomer, setSelectedCustomer] = useState("All");
useEffect(() => {
  axios.get(`${process.env.REACT_APP_BASE_API_URL}/api/customers`)
    .then(res => {
      const list = res.data.customers || res.data;
      console.log("customers sample:", list[0]);   // 👈 check field name
      setCustomers(list);
    })
    .catch(err => console.error(err));
}, []);
  const [limit, setLimit] = useState(10);
  const totalPages = Math.ceil(total / limit);
  const [feedbacks, setFeedbacks] = useState([]);
  const handleTimeRange = (range) => {
    setActiveTimeRange(range);
    const today = new Date();
    let pastDate = new Date();

    if (range === "1 wk") pastDate.setDate(today.getDate() - 7);
    else if (range === "1 mo") pastDate.setMonth(today.getMonth() - 1);
    else if (range === "3 mo") pastDate.setMonth(today.getMonth() - 3);

    const formatDate = (date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    setStartDate(formatDate(pastDate));
    setEndDate(formatDate(today));
    setPage(1); // Reset to page 1 on filter change
  };
  useEffect(() => {
    fetchFeedbacks();
  }, [page, limit, startDate, endDate, status, selectedCustomer]);

  const downloadPDF = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/api/feedbacks`, {
        params: {
          page: 1,
          limit: 10000,
          startDate,
          endDate,
          status,
          customer: selectedCustomer
        }
      });

      const data = res.data.data;

      if (!data.length) {
        alert("No data to download");
        return;
      }

      const doc = new jsPDF();

      // Title
      doc.setFontSize(16);
      doc.text("Feedback Report", 14, 15);

      // Table
      const tableData = data.map((f) => [
        f.customer,
        f.email,
        "★".repeat(parseInt(f.rating, 10) || 0),
        f.support_response || "-",
        f.message || "-",
        new Date(f.createdOn).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" })
      ]);

      autoTable(doc, {
        startY: 25,
        head: [["Customer", "Email", "Rating", "Response", "Message", "Date"]],
        body: tableData,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [51, 124, 138] }, // your theme color
      });

      doc.save("feedbacks.pdf");

    } catch (err) {
      console.error(err);
      alert("PDF download failed");
    }
  };
  const fetchFeedbacks = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/api/feedbacks`, {
        params: {
          page,
          limit,
          startDate,
          endDate,
          status,
          customer: selectedCustomer
        }
      });

      setFeedbacks(res.data.data);
      setTotal(res.data.total);
    } catch (err) {
      console.error(err);
    }
  };
  const resetFilters = () => {
    setStartDate("");
    setEndDate("");
    setStatus("All");
    setSelectedCustomer("All"); // ✅ ADD THIS
    setActiveTimeRange("");
    setPage(1);
  };
  return (<>
    <div className="ms-4 ">

      <div className="mt-4 d-flex">

        <div className="d-flex align-items-center mb-4">
          {/* Title and Description */}
          <div>
            <h4>Feedback </h4>
            <p>View assigned queries, track leads, and manage sales activities in one place.</p>
          </div>
        </div>
        <div className="ms-auto p-3">
          <button className="download-btn" onClick={downloadPDF}>    <i className="bi bi-download me-2"></i>
            Download
          </button>
        </div>
      </div>
      <div className="shadow-sm rounded border border bg-white">
        <div className="d-flex align-items-center flex-wrap gap-3 ps-3 pb-4">

          {/* Time Range */}
          <div className="d-flex align-items-center mt-4">
            <span>Time Range:</span>
            <div className="btn-group btn-grp ms-3">
              {["1 wk", "1 mo", "3 mo"].map((range) => (
                <button
                  key={range}
                  className="btn border"
                  onClick={() => handleTimeRange(range)}
                  style={{
                    borderRadius: "30px",
                    marginRight: "8px",
                    backgroundColor: activeTimeRange === range ? "#2F7A87" : "transparent",
                    color: activeTimeRange === range ? "#fff" : "#6c757d",
                    borderColor: activeTimeRange === range ? "#2F7A87" : "#6c757d",
                  }}
                >
                  {range}
                </button>
              ))}
            </div>
          </div>

          {/* Date Range Wrapper */}
          <div className="d-flex align-items-center gap-3 mt-4">
            {/* Start Date */}
            <div className="d-flex align-items-center bg-white rounded">
              <label htmlFor="startDate" className="form-label mb-0 me-2">Start</label>
              <input
                id="startDate"
                type="date"
                className="form-control btn-grp"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  setActiveTimeRange(""); // reset buttons
                }}
                style={{ width: "150px", borderRadius: "30px" }}
              />
            </div>

            {/* End Date */}
            <div className="d-flex align-items-center bg-white rounded">
              <label htmlFor="endDate" className="form-label mb-0 me-2">End</label>
              <input
                id="endDate"
                type="date"
                className="form-control btn-grp"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                  setActiveTimeRange(""); // reset buttons
                }}
                style={{ width: "150px", borderRadius: "30px" }}
              />
            </div>
          </div>

          {/* Status */}
          <div className="d-flex align-items-center gap-2 mt-4">
            <span>Customer:</span>

            <Dropdown>
         <Dropdown.Toggle
  bsPrefix="btn"
  className="btn border d-flex align-items-center justify-content-between btn-grp"
  style={{
    borderRadius: "30px",
    width: "120px",
    maxWidth: "120px",
    backgroundColor: "transparent",
    color: "#6c757d",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    paddingRight: "8px"
  }}
>
  <span
    style={{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      flex: 1,
      minWidth: 0,
      textAlign: "left"
    }}
    title={selectedCustomer}   // 👈 shows full name on hover
  >
    {selectedCustomer}
  </span>
  <i className="bi bi-chevron-down ms-2" style={{ flexShrink: 0 }}></i>
</Dropdown.Toggle>

              <style>
                {`
                  .lean-scrollbar::-webkit-scrollbar {
                    width: 6px;
                  }
                  .lean-scrollbar::-webkit-scrollbar-track {
                    background: transparent;
                  }
                  .lean-scrollbar::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 10px;
                  }
                  .lean-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #a8a8a8;
                  }
                `}
              </style>
              <Dropdown.Menu className="lean-scrollbar" style={{ borderRadius: "20px", maxHeight: "250px", overflowY: "auto" }}>
                <Dropdown.Item onClick={() => setSelectedCustomer("All")}>
                  All
                </Dropdown.Item>

{customers.map((c) => (
  <Dropdown.Item
    key={c.id}
    onClick={() => setSelectedCustomer(c.full_name)}
  >
    {c.full_name}
  </Dropdown.Item>
))}
              </Dropdown.Menu>
            </Dropdown>

          </div>
          <div className="d-flex align-items-center mt-4 gap-2" style={{ cursor: "pointer", color: "#333" }} onClick={resetFilters} title="Reset Filters">
            <img
              src="/images/filter.svg"
              alt="Reset Filters"
              style={{ width: '16px', height: '16px' }}
            />
            <span style={{ fontWeight: 400, fontSize: "14px" }}>Reset Filters</span>
          </div>
        </div>

        <div className="feedback-table-wrapper">
          <Table hover responsive className="mt-2" style={{ width: "100%", minWidth: "65rem", tableLayout: "fixed" }}>
            <thead className="ms-3" >
              <tr className="text-muted ms-3">
                <th style={{ width: "15%" }}>Customer</th>
                <th style={{ width: "15%" }}>Company</th>
                <th style={{ width: "18%" }}>Email ID</th>
                <th style={{ width: "10%" }}>Rating</th>
                <th style={{ width: "10%" }}>Response</th>
                <th style={{ width: "14%" }}>Message</th>
                <th style={{ width: "10%" }}>Submitted On</th>
                <th style={{ width: "8%", textAlign: "center" }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {feedbacks.map((item) => (
                <tr key={item._id}>
                  <td><div className="text-truncate" title={item.customer}>{item.customer}</div></td>
                  <td><div className="text-truncate" title={item.company}>{item.company || "-"}</div></td>
                  <td><div className="text-truncate" title={item.email}>{item.email}</div></td>

                  <td style={{ color: "#f4c430" }}>
                    {"★".repeat(parseInt(item.rating, 10) || 0)}
                    {"☆".repeat(5 - (parseInt(item.rating, 10) || 0))}
                  </td>

                  <td><div className="text-truncate" title={item.support_response}>{item.support_response || "-"}</div></td>

                  <td
                    style={{
                      whiteSpace: "normal",
                      wordWrap: "break-word"
                    }}
                  >
                    {item.message || "-"}
                  </td>

                  <td>
                    {item.createdOn
                      ? new Date(item.createdOn).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" })
                      : "-"}
                  </td>

                  <td style={{ textAlign: "center" }}>
                    <Dropdown drop="start">
                      <Dropdown.Toggle as="div" style={{ cursor: 'pointer', display: 'inline-block' }} bsPrefix="p-0">
                        <i className="bi bi-three-dots-vertical"></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleEdit(item)}>Edit</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDeleteClick(item)}>Delete</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-end me-3">
          <ResultsPagination
            activePage={page}
            setActivePage={setPage}
            perPage={limit}
            setPerPage={setLimit}
            totalPages={totalPages}
            perPageOptions={[5, 10, 20, 50]}
          />
        </div>
      </div>
    </div>

    <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Feedback</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Customer</Form.Label>
            <Form.Control type="text" name="customer" value={editFormData.customer} onChange={handleEditChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Company</Form.Label>
            <Form.Control type="text" name="company" value={editFormData.company} onChange={handleEditChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email ID</Form.Label>
            <Form.Control type="email" name="email" value={editFormData.email} onChange={handleEditChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Rating (1-5)</Form.Label>
            <Form.Control type="number" min="1" max="5" name="rating" value={editFormData.rating} onChange={handleEditChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Response</Form.Label>
            <Form.Control type="text" name="support_response" value={editFormData.support_response} onChange={handleEditChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Message</Form.Label>
            <Form.Control as="textarea" rows={3} name="message" value={editFormData.message} onChange={handleEditChange} />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          style={{ 
            backgroundColor: "white", 
            border: "1px solid #2F7F8F", 
            color: "#2F7F8F",
            padding: "6px 12px",
            borderRadius: "20px",
            cursor: "pointer"
          }}
          onClick={() => setShowEditModal(false)}
        >
          Cancel
        </button>
        <button
          type="button"
          style={{ 
            backgroundColor: "#2F7F8F", 
            border: "1px solid #2F7F8F", 
            color: "white",
            padding: "6px 12px",
            borderRadius: "20px",
            cursor: "pointer"
          }}
          onClick={saveEdit}
        >
          Save Changes
        </button>
      </Modal.Footer>
    </Modal>

    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this feedback? This action cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          style={{ 
            backgroundColor: "white", 
            border: "1px solid #2F7F8F", 
            color: "#2F7F8F",
            padding: "6px 12px",
            borderRadius: "20px",
            cursor: "pointer"
          }}
          onClick={() => setShowDeleteModal(false)}
        >
          Cancel
        </button>
        <button
          type="button"
          style={{ 
            backgroundColor: "#2F7F8F", 
            border: "1px solid #2F7F8F", 
            color: "white",
            padding: "6px 12px",
            borderRadius: "20px",
            cursor: "pointer"
          }}
          onClick={confirmDelete}
        >
          Delete
        </button>
      </Modal.Footer>
    </Modal>

  </>)
}
export default FeedBackSales